import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_PoliciesList = _resolveComponent("PoliciesList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.policies')
    }, null, 8 /* PROPS */, ["page"]),
    _createVNode(_component_PoliciesList)
  ], 64 /* STABLE_FRAGMENT */))
}